import { deviceDashboardTypes } from "../actions/deviceDashboard";
import { deviceShipmentsDashboardTypes } from "../actions/deviceShipmentsDashboard";
const initialDate = new Date();

const initialState = {
  currentId: "",
  isRefresh: false,
  isLoading: {
    rssiHistory: false,
    humidity: false,
    signal: false,
    battery: false,
    pressure: false,
    light: false,
    tilt: false,
    gatewayTelemetryHistory: false,
   temperature: false,
    shockAlarmHistory: false,
  },
  resolutionFilters: {
    rssi: {
      duration: "7 days",
      resolution: "15 minutes",
    },
    battery: {
      duration: "7 days",
      resolution: "15 minutes",
    },
    signalStrength: {
      duration: "7 days",
      resolution: "15 minutes",
    },
    Pressure: {
      duration: "7 days",
      resolution: "15 minutes",
    },
    shockAlarm: {
      duration: "7 days",
      resolution: "15 minutes",
    },
  },
  isFullScreenMode: false,
  displayOpt: "most_recent",
  selectedDateTime: `${initialDate.getFullYear()}-${
    (initialDate.getMonth() + 1).toString()
    .padStart(2, "0")
  }-${initialDate
    .getDate()
    .toString()
    .padStart(2, "0")}T${initialDate.toLocaleTimeString({
    hour12: false,
  })}`,
  resolutionTime: 15 * 60 * 1000,
  data: {
    rssiHistory: [],
    Humidity:{
      timeAgo: "",
      humidity: [],
    },
    signalHistory: [],
    batteryHistory: {
      timeAgo: "",
      battery: [],
    },
    Pressure: {
      timeAgo: "",
      pressure: [],
    },
    Temperature: {
      timeAgo: "",
      temperature: [],
    },
    Light: {
      timeAgo: "",
      light: [],
    },
    Tilt: {
      timeAgo: "",
      tilt: [],
    },
    shockAlarmHistory: {
      timeAgo: "",
      shock: [],
    },
  },
  error: {
    shockAlarmHistory: null,
  },
};

const deviceShipmentsDashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case deviceDashboardTypes.UPDATE_REQUEST:
      return {
        ...state,
        ...action.payload,
      };
    case deviceShipmentsDashboardTypes.FETCH_RSSI_HISTORY_REQUEST:
      return {
        ...state,
        currentId: action.payload.id,
        startDateTime:action.payload.startDateTime,
        endDateTime:action.payload.endDateTime,
        isAsc: action.payload.isAsc,
        isLoading: {
          ...state.isLoading,
          rssiHistory: true
        },
        resolutionFilters:
          action.payload.resolutionFilterKey && action.payload.resolutionFilter
            ? {
                ...state.resolutionFilters,
                [action.payload.resolutionFilterKey]:
                  action.payload.resolutionFilter,
              }
            : state.resolutionFilters,
      };
    case deviceShipmentsDashboardTypes.FETCH_HUMIDITY_REQUEST:
      return {
        ...state,
        currentId: action.payload.id,
        startDateTime:action.payload.startDateTime,
        endDateTime:action.payload.endDateTime,
        isLoading: {
          ...state.isLoading,
          humidity: true
        }
      };
    case deviceShipmentsDashboardTypes.FETCH_LIGHT_REQUEST:
      return {
        ...state,
        currentId: action.payload.id,
        startDateTime: action.payload.startDateTime,
        endDateTime: action.payload.endDateTime,
        isLoading: {
          ...state.isLoading,
          light: true
        }
      };
    case deviceShipmentsDashboardTypes.FETCH_TILT_REQUEST:
      return {
        ...state,
        currentId: action.payload.id,
        startDateTime: action.payload.startDateTime,
        endDateTime: action.payload.endDateTime,
        isLoading: {
          ...state.isLoading,
          tilt: true
        }
      };
    case deviceShipmentsDashboardTypes.FETCH_SIGNAL_HISTORY_REQUEST:
      return {
        ...state,
        currentId: action.payload.id,
        startDateTime:action.payload.startDateTime,
        endDateTime:action.payload.endDateTime,
        isLoading: {
          ...state.isLoading,
          signal: true
        },
        resolutionFilters:
          action.payload.resolutionFilterKey && action.payload.resolutionFilter
            ? {
                ...state.resolutionFilters,
                [action.payload.resolutionFilterKey]:
                  action.payload.resolutionFilter,
              }
            : state.resolutionFilters,
      };
    case deviceShipmentsDashboardTypes.FETCH_BATTERY_HISTORY_REQUEST:
      return {
        ...state,
        currentId: action.payload.id,
        startDateTime:action.payload.startDateTime,
        endDateTime:action.payload.endDateTime,
        isLoading: {
          ...state.isLoading,
          battery: true
        },
        resolutionFilters:
          action.payload.resolutionFilterKey && action.payload.resolutionFilter
            ? {
                ...state.resolutionFilters,
                [action.payload.resolutionFilterKey]:
                  action.payload.resolutionFilter,
              }
            : state.resolutionFilters,
      };
    case deviceShipmentsDashboardTypes.FETCH_PRESSURE_REQUEST:
      return {
        ...state,
        currentId: action.payload.id,
        startDateTime:action.payload.startDateTime,
        endDateTime:action.payload.endDateTime,
        isLoading: {
          ...state.isLoading,
          pressure: true
        },
        resolutionFilters:
          action.payload.resolutionFilterKey && action.payload.resolutionFilter
            ? {
                ...state.resolutionFilters,
                [action.payload.resolutionFilterKey]:
                  action.payload.resolutionFilter,
              }
            : state.resolutionFilters,
      };
      case deviceShipmentsDashboardTypes.FETCH_TEMPERATURE_REQUEST:
        return {
          ...state,
          currentId: action.payload.id,
          startDateTime:action.payload.startDateTime,
          endDateTime:action.payload.endDateTime,
          isLoading: {
            ...state.isLoading,
            temperature: true,
          }
        };
    case deviceShipmentsDashboardTypes.FETCH_RSSI_HISTORY_SUCCESS:
      return {
        ...state,
        isRefresh: false,
        isLoading: {
          ...state.isLoading,
          rssiHistory: false,
        },
        data: {
          ...state.data,
          rssiHistory: action.payload,
        },
        error: {
          rssiHistory: null,
        },
      };
    case deviceShipmentsDashboardTypes.FETCH_RSSI_HISTORY_FAILURE:
      return {
        ...state,
        isRefresh: false,
        isLoading: {
          ...state.isLoading,
          rssiHistory: false,
        },
        error: {
          rssiHistory: action.payload,
        },
      };
    case deviceShipmentsDashboardTypes.FETCH_HUMIDITY_SUCCESS:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          humidity: false,
        },
        data: {
          ...state.data,
          Humidity: action.payload,
        },
        error: {
          Humidity: null,
        },
      };
    case deviceShipmentsDashboardTypes.FETCH_HUMIDITY_FAILURE:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          humidity: false,
        },
        error: {
          Humidity: action.payload,
        },
      };
    case deviceShipmentsDashboardTypes.FETCH_LIGHT_SUCCESS:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          light: false,
        },
        data: {
          ...state.data,
          Light: action.payload,
        },
        error: {
          Light: null,
        },
      };
    case deviceShipmentsDashboardTypes.FETCH_LIGHT_FAILURE:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          light: false,
        },
        error: {
          Light: action.payload,
        },
      };
    case deviceShipmentsDashboardTypes.FETCH_TILT_SUCCESS:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          tilt: false,
        },
        data: {
          ...state.data,
          Tilt: action.payload,
        },
        error: {
          Tilt: null,
        },
      };
    case deviceShipmentsDashboardTypes.FETCH_TILT_FAILURE:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          tilt: false,
        },
        error: {
          Tilt: action.payload,
        },
      };
    case deviceShipmentsDashboardTypes.FETCH_BATTERY_HISTORY_SUCCESS:
      return {
        ...state,
        isRefresh: false,
        isLoading: {
          ...state.isLoading,
          battery: false,
        },
        data: {
          ...state.data,
          batteryHistory: action.payload,
        },
        error: {
          batteryHistory: null,
        },
      };
    case deviceShipmentsDashboardTypes.FETCH_BATTERY_HISTORY_FAILURE:
      return {
        ...state,
        isRefresh: false,
        isLoading: {
          ...state.isLoading,
          battery: false,
        },
        error: {
          batteryHistory: action.payload,
        },
      };
    case deviceShipmentsDashboardTypes.FETCH_PRESSURE_SUCCESS:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          pressure: false,
        },
        data: {
          ...state.data,
          Pressure: action.payload,
        },
        error: {
          Pressure: null,
        },
      };
    case deviceShipmentsDashboardTypes.FETCH_PRESSURE_FAILURE:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          pressure: false,
        },
        error: {
          Pressure: action.payload,
        },
      };
      case deviceShipmentsDashboardTypes.FETCH_TEMPERATURE_SUCCESS:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          temperature: false,
        },
        data: {
          ...state.data,
         Temperature: action.payload,
        },
        error: {
          Temperature: null,
        },
      };
    case deviceShipmentsDashboardTypes.FETCH_TEMPERATURE_FAILURE:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          temperature: false,
        },
        error: {
          Temperature: action.payload,
        },
      };
    case deviceShipmentsDashboardTypes.FETCH_SIGNAL_HISTORY_SUCCESS:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          signal: false,
        },
        data: {
          ...state.data,
          signalHistory: action.payload,
        },
        error: {
          signalHistory: null,
        },
      };
    case deviceShipmentsDashboardTypes.FETCH_SIGNAL_HISTORY_FAILURE:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          signal: false,
        },
        error: {
          signalHistory: action.payload,
        },
      };
    case deviceShipmentsDashboardTypes.FETCH_SHOCK_ALARM_HISTORY_REQUEST:
      return {
        ...state,
        currentId: action.payload.id,
        startDateTime: action.payload.startDateTime,
        endDateTime: action.payload.endDateTime,
        isAsc: action.payload.isAsc,
        isLoading: {
          ...state.isLoading,
          shockAlarmHistory: true,
        },
        error: {
          ...state.error,
          shockAlarmHistory: null,
        },
      };
    case deviceShipmentsDashboardTypes.FETCH_SHOCK_ALARM_HISTORY_SUCCESS:
      const { shock, shockDetails } = action.payload;
      const shockArray = Object.entries(shock || {}).map(([timestamp, magnitude]) => {
        const details = (shockDetails || []).find(d => d.timestamp === timestamp) || {};
        return [timestamp, magnitude, details];
      }).sort((a, b) => new Date(a[0]) - new Date(b[0]));

      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          shockAlarmHistory: false,
        },
        data: {
          ...state.data,
          shockAlarmHistory: {
            timeAgo: action.payload.timeAgo || "",
            shock: shockArray,
          },
        },
        error: {
          ...state.error,
          shockAlarmHistory: null,
        },
      };
    case deviceShipmentsDashboardTypes.FETCH_SHOCK_ALARM_HISTORY_FAILURE:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          shockAlarmHistory: false,
        },
        error: {
          ...state.error,
          shockAlarmHistory: action.payload,
        },
      };
    default:
      return state;
  }
};

export default deviceShipmentsDashboardReducer;
